<template>
	<div @click="close_selection += 1">
		<ProgressLinear v-if="loading"/>
		<v-alert dense class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ errorMessageFormat(error_msg) }}
		</v-alert>
		<template v-if="!loading">
			<v-row class="mx-4 mt-5 mb-0" :justify="$vuetify.breakpoint.smAndUp ? 'space-between':'start'" align="center">
				<div>
					<span class="file-list-title" style="color: #4742C6">Matches&nbsp;</span>
					<span class="file-list-text" style="color: #F45252; font-size: 16px; font-weight: 700;">&nbsp;{{ exception_holding_num }}&nbsp;new</span>
				</div>
				<v-row class="ma-0 py-1" :justify="$vuetify.breakpoint.smAndUp ? 'end':'space-between'" align="center">
					<v-menu offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
								class="text-capitalize ml-4 px-3"
								color="#FAFAFA"
								max-height="32"
								min-height="32"
								v-bind="attrs"
								v-on="on"
								@click="is_down = !is_down"
							>
								<ColumnsTable :color="'#82899B'" width="20" height="20" class="mr-2"/>
								<span class="mr-3 font-bold-style" style="color: rgba(25, 42, 62, 0.7)">Columns</span>
								<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div style="min-width: 226px;height: 68vh;background-color: white;">
							<div class="tree-wrap">
								<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
									<v-list-item dense>
										<v-checkbox
											class="mt-0 pt-0"
											v-model="select_columns"
											:label="item.text"
											:value="item"
											:color="color"
											dense
											hide-details
											@change="onSelectColumn()"
										></v-checkbox>
									</v-list-item>
								</div>
							</div>
						</div>
					</v-menu>
				</v-row>
			</v-row>
			<v-expansion-panels v-model="panel" flat accordion>
				<v-expansion-panel
					v-for="(detail, i) in panel_details"
					:key="i"
				>
					<v-expansion-panel-header style="padding: 0 16px; align-items: flex-start; min-height: 48px;">
						<v-row class="panel-header font-bold-style ma-0" style="line-height: 36px;">
							<div class="my-1 px-1" style="background-color: #FAFAFA; height: 40px" :style="`color: ${color}`">{{ detail.job.jocode }} - {{ detail.job.joshort }}</div>
							<v-menu
								:key="detail.id"
								v-model="detail.menu"
								:close-on-content-click="false"
								offset-y
								min-width="auto"
								@click.stop
							>
								<template v-slot:activator="{ on, attrs }">
									<v-row v-bind="attrs" v-on="on" class="mx-4 my-1 px-3" style="max-width: 160px; background-color: #FAFAFA; flex-wrap: nowrap;" align="center">
										<div style="width: 24px; height: 28px">
											<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
										</div>
										<div class="font-bold-style">{{ formatDateRange(detail.date) }}</div>
									</v-row>
								</template>
								<v-card @click.stop>
									<v-date-picker
										v-model="detail.date"
										:color="color"
										:picker-date.sync="detail.month"
										no-title
										multiple
										scrollable
										range
										@change="onDateChange($event, detail.id)">
									</v-date-picker>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastWeek(detail.id)">Last week</v-btn>
									</v-row>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastMonth(detail.id)">Last month</v-btn>
									</v-row>
								</v-card>
							</v-menu>
						</v-row>
						<template v-slot:actions>
							<v-row class="panel-icon mt-2 mx-0 mb-0 px-2" style="background-color: #FAFAFA; height: 40px;">
								<v-icon v-if="is_down" :color="color">mdi-chevron-up</v-icon>
								<v-icon v-if="!is_down" :color="color">mdi-chevron-down</v-icon>
							</v-row>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-data-table
							:headers="headers"
							:items="detail['holdings']"
							:items-per-page="countPerpage"
							:page.sync="page"
							:loading="detail.table_loading"
							item-key="id"
							hide-default-header
							hide-default-footer
						>
							<template v-slot:header="{ props: { headers } }">
								<thead>
									<tr>
										<th v-for="header in headers" :key="header.value" class="header-background-color">
											<v-row class="ma-0 px-3 table-header-row">
												<span class="font-bold-style font-header-style">{{ header.text }}&nbsp;</span>
											</v-row>
										</th>
									</tr>
								</thead>
							</template>
							<template v-slot:body="{ items, headers }">
								<tbody>
									<template v-if="items.length === 0">
										<tr>
											<td :colspan="headers.length">
												<v-row class="font-normal-style font-header-style ma-0 px-3" justify="start" style="line-height: 48px">
													<div class="font-bold-style font-header-style mx-2" style="font-size: 16px;">{{ detail.table_text }}</div>
												</v-row>
											</td>
										</tr>
									</template>
									<template v-else>
										<tr v-for="(item_obj, index) in items" :key="index" :style="item_obj.parent_id !== 0 ? 'background-color: #FAFAFF':''">
											<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="getRowStyle(item_obj)">
												<div v-if="key === 'phase'" class="holding-cell">
													<v-row v-if="item_obj.parent_id === 0" justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item.desc}}</span>
													</v-row>
												</div>
												<div v-if="key === 'outlet'" class="holding-cell">
													<v-row v-if="item_obj.parent_id === 0" justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item_obj.original_outlet" class="long-text font-normal-style">{{ item ? item.desc : '' }}</span>
													</v-row>
												</div>
												<div v-if="key === 'kind'" class="holding-cell">
													<v-row v-if="item_obj.parent_id === 0" justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item_obj.has_child" class="long-text font-normal-style">{{ item ? item.display_name : '' }}</span>
													</v-row>
												</div>
												<div v-if="key === 'station_name'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<v-card tile elevation="0" color="transparent">
															<span class="font-normal-style truncate-2">{{ item }}</span>
														</v-card>
													</v-row>
												</div>
												<div v-if="key === 'media_reference_id'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
														<v-btn v-if="item" icon small class="ml-3" @click.stop="onHistoryClick(item)">
															<v-icon color="rgba(25, 42, 62, 0.25)" size="22">mdi-history</v-icon>
														</v-btn>
													</v-row>
												</div>
												<div v-if="key === 'contract_ref'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item.length === 0 ? '' : formatDate(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_day_flags'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-for="(flag, index) in item" :key="index" class="font-normal-style mr-1" style="color:#605AF6">
															<span v-if="flag === '1'" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ week_flag[index] }}&nbsp;</span>
															<span v-else>-&nbsp;</span>
														</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_duration'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_end_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'rate_fc'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item_obj.cost_currency && item !== null" class="font-normal-style mr-1">{{ item_obj.cost_currency.symbol }}</span>
														<span v-if="item !== null" class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'value_fc'" class="holding-cell">
													<v-row v-if="item !== null" justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style mr-1">{{ item_obj.value_currency.symbol }}</span>
														<span class="font-normal-style">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'program_name'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'pos_in_break'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'material_key_identifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'priority_modifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'custom1'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom2'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom3'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom4'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom5'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
							<template v-slot:footer>
								<div class="pagination">
									<v-pagination
										v-model="page"
										:color="color"
										:length="getPaginationTotal(detail['holdings'].length)"
										:total-visible="$vuetify.breakpoint.xs ? 3: 5"
										circle
									></v-pagination>
									<div class="pagination-text">show</div>
									<div class="pagination-text-page">{{ countPerpage}}/page</div>
									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on"><Down class="down"/></div>
										</template>
										<v-list>
											<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" style="width: 24px;" @click="onClickOption(pageOption)">
												{{pageOption}}
											</v-list-item-title>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-data-table>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</template>
		<HistoryDialog
			v-if="history_visible"
			:visible="history_visible"
			:refId="history_ref_id"
			@input="history_visible = $event"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import ColumnsTable from "@/components/icons/columns_table.vue";
import Calendar from "@/components/icons/calendar.vue";
import Down from '@/components/icons/down';
import HistoryDialog from "@/views/desktop/media/radio_holdings/media_holding_history_dialog";

import moment from 'moment';
import config from "@/config.js";

const Week_Flag = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const Table_Headers = [
	{
		text: 'Phase',
		showable: true,
		value: 'phase',
		width: 200
	},
	{
		text: 'Media Outlet',
		showable: true,
		value: 'outlet',
		width: 200
	},
	{
		text: 'Kind',
		showable: true,
		value: 'kind',
		width: 200
	},
	{
		text: 'Station',
		showable: true,
		value: 'station_name',
		width: 200
	},
	{
		text: 'Media Reference ID',
		showable: true,
		value: 'media_reference_id',
		width: 200
	},
	{
		text: 'Contract Ref',
		showable: true,
		value: 'contract_ref',
		width: 200
	},
	{
		text: 'Booked Date',
		showable: true,
		value: 'booking_start',
		width: 200
	},
	{
		text: 'Booked Day Flags',
		showable: true,
		value: 'booking_day_flags',
		width: 200
	},
	{
		text: 'Duration',
		showable: true,
		value: 'booking_duration',
		width: 200
	},
	{
		text: 'Start Time',
		showable: true,
		value: 'booking_start_time',
		width: 200
	},
	{
		text: 'End Time',
		showable: true,
		value: 'booking_end_time',
		width: 200
	},
	{
		text: 'Supplier rate',
		showable: true,
		value: 'rate_fc',
		width: 200
	},
	{
		text: 'Bill to client',
		showable: true,
		value: 'value_fc',
		width: 200
	},
	{
		text: 'Program Name',
		showable: true,
		value: 'program_name',
		width: 200
	},
	{
		text: 'Position in Break',
		showable: true,
		value: 'pos_in_break',
		width: 200
	},
	{
		text: 'Material Key Number',
		showable: true,
		value: 'material_key_identifier',
		width: 200
	},
	{
		text: 'Priority Modifier',
		showable: true,
		value: 'priority_modifier',
		width: 200
	},
	// {
	// 	text: 'Custom 1',
	// 	showable: true,
	// 	value: 'custom1',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 2',
	// 	showable: true,
	// 	value: 'custom2',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 3',
	// 	showable: true,
	// 	value: 'custom3',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 4',
	// 	showable: true,
	// 	value: 'custom4',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 5',
	// 	showable: true,
	// 	value: 'custom5',
	// 	width: 200
	// }
];

const Error_Flag = 'Traffic;';
const Diff_Flag = 'diff_';
const Reject_Status = 2;

/** Markup -> 0, Commission -> 1 */
const Markup_Mode = 0;
const Commission_Mode = 1;

const Un_Matched_Text = 'There are no matching bookings.';
const Setting_Name = 'RadioMatches';

export default {
	name: 'MediaHoldingMatches',
	props: {
		color: {
			type: String,
			default: ''
		},
		fileId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.week_flag = Week_Flag;
		this.diff_flag = Diff_Flag;
		this.kind_params = {
			select_items: true,
			select_kinds: true,
			expense_kinds: true,
			overhead_mode: 0,
			billable_kinds: true,
		};

		return {
			loading: false,
			error_msg: '',
			close_selection: 0,
			user_id: 0,

			headers: Table_Headers,
			exception_holding_num: 0,
			panel_details: [],
			panel_details_orignal: [],

			supplier_items: [],
			job_list: [],

			is_down: true,
			columns: Table_Headers,
			select_columns: Table_Headers,

			panel: null,

			page: 1,
			countPerpage: 10,
			pageOptions: config.pageOptions,

			history_visible: false,
			history_ref_id: ''
		}
	},
	components: {
		ProgressLinear,
		ColumnsTable,
		Calendar,
		Down,
		HistoryDialog
	},
	async created() {
		await this.getUserId();
		await this.getSettings();
		await this.getSupplierList();

		this.getMatchJobs(this.fileId);
	},
	computed: {
		isColumnDiff() {
			let is_diff = false;

			if (this.select_columns.length !== this.columns.length) {
				is_diff = true;
			}

			return is_diff;
		}
	},
	watch: {
		async panel() {
			if (this.panel !== undefined && this.panel !== null) {
				const detail = this.panel_details[this.panel];

				if (detail) {
					await this.getMatchHoldings(this.fileId, detail.id);
				}
			}
		},
		select_columns() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const header_obj = Table_Headers.filter(header => { return columns.includes(header.value) });
			
			this.headers = header_obj;
		}
	},
	methods: {
		async getUserId() {
			this.loading = true;

			const url = '/api/user/me';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getSettings() {
			this.loading = true;

			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);

								const column = windata.column;
								if (column) {
									const columns_orignal = Table_Headers.filter(header => { return header.value !== 'checkbox'});

									const select_columns_view = [];
									columns_orignal.forEach(c => {
										if (column.includes(c.value)) {
											select_columns_view.push(c);
										} 
									});

									this.select_columns = select_columns_view;
								}
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;
						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		getMatchJobs(file_id) {
			this.loading = true;

			const url = `/api/media/media_planning/import_export/${file_id}/get_match_jobs`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const grouped_jobs = Object.values(data.reduce((jobs_by_id, job) => {
							if (!jobs_by_id[job.joid]) {
								jobs_by_id[job.joid] = {
									...job,
									item_count: Number(job.item_count) || 0,
								};
							} else {
								jobs_by_id[job.joid].item_count += Number(job.item_count) || 0;
							}

							return jobs_by_id;
						}, {})).sort((job_a, job_b) => {
							const job_code_compare = (job_a.jocode || '').localeCompare(job_b.jocode || '');
							if (job_code_compare !== 0) {
								return job_code_compare;
							}

							return (job_a.joshort || '').localeCompare(job_b.joshort || '');
						});
						
						grouped_jobs.forEach((job, index) => {
							if (job.item_count !== 0) {
								this.exception_holding_num += job.item_count;

								const date_start = moment(job.date_from).format('YYYY-MM-DD');
								const date_end = moment(job.date_to).format('YYYY-MM-DD');

								const obj = {
									id: job.joid,
									down: index === 0,
									menu: false,
									check: false,
									job: job,
									holdings: [],
									date: [date_start, date_end],
									month: date_start.substring(0, 7),
									phase: null,
									phase_items: [],
									table_loading: false,
									table_text: ''
								};

								this.panel_details.push(obj);
								this.panel_details_orignal.push(JSON.parse(JSON.stringify(obj)));
							}
						});

						/** open the first job */
						this.panel = 0;
							
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async getMatchHoldings(file_id, job_id) {
			this.panel_details.forEach(detail => {
				if (detail.id === job_id) {
					detail.holdings = [];
					detail.table_loading = true;
					detail.table_text = '';
				}
			});

			let url = `/api/media/media_planning/import_export/${file_id}/match_holdings`;
			
			const params = [];
			params.push("job_id=" + job_id);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;

					if (status == "OK") {
						const supplier_ids_by_station_code = {};
						if (data[0].stations) {
							data[0].stations.forEach(station => {
								if (station.media_supplier_link !== null && station.media_supplier_link.media_supplier !== null) {
									supplier_ids_by_station_code[`${station.code}`] = station.media_supplier_link.media_supplier.id;
								}
							});
						}

						const job_by_product_code = {};
						if (data[0].products) {
							data[0].products.forEach(product => {
								if (product.job_link.job !== null) {
									job_by_product_code[`${product.code}`] = product.job_link.job;
								}
							});
						}

						const network_code = data[0].network_code;
						const holdings = [];

						if (data[0].items) {
							data[0].items.forEach(item => {
								if (job_by_product_code[`${item.product}`] && item.status !== Reject_Status) {
									const job = job_by_product_code[`${item.product}`];

									if (item.bookings && item.bookings.length !== 0) {
										const item_new_arr = this.getRowWithBooking(item, network_code)

										if (item_new_arr.length !== 0) {
											const item_new = item_new_arr[0];
											item_new['job_id'] = job.id;

											const station_obj = data[0].stations.filter(station => { return station.code === item.station });
											item_new['station_name'] = `${station_obj[0].code} - ${station_obj[0].description}`;

											holdings.push(item_new);
										}
									}
								}
							});
						}

						this.panel_details.forEach(detail => {
							if (detail.id === job_id) {
								detail.holdings = JSON.parse(JSON.stringify(holdings));
								detail.table_loading = false;
								detail.table_text = detail.holdings.length === 0 ? Un_Matched_Text : '';
							}
						});

						this.panel_details_orignal.forEach(detail => {
							if (detail.id === job_id) {
								detail.holdings = JSON.parse(JSON.stringify(holdings));
							}
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.panel_details.forEach(detail => {
						if (detail.id === job_id) {
							detail.table_loading = false;
						}
					});
				});
		},
		getRowWithBooking(item, network_code) {
			let is_exception = true;

			/** compare the diff */
			const diff_item = {};

			const booking = item.bookings[0];
			diff_item[`${this.diff_flag}network_code`] = booking.network_code === network_code ? false : true;
			diff_item[`${this.diff_flag}media_reference_id`] = booking.media_reference_id === item.media_ref ? false : true;
			diff_item[`${this.diff_flag}contract_ref`] = booking.contract_ref === item.contract ? false : true;
			diff_item[`${this.diff_flag}booking_day_flags`] = booking.booking_day_flags === item.day_flags ? false : true;
			
			const item_booked_date = this.calculateBookedDate(item.booked_date, item.day_flags);
			const booking_booked_date = this.calculateBookedDate(booking.booked_date, booking.booking_day_flags);	
			diff_item[`${this.diff_flag}booking_start`] = booking.booked_date && booking.booked_date.length !== 0 && item.booked_date && item.booked_date.length !== 0 && item_booked_date === booking_booked_date ? false : true;

			diff_item[`${this.diff_flag}duration`] = booking.booking_duration === item.duration ? false : true;
			diff_item[`${this.diff_flag}booking_start_time`] = booking.booking_start_time === item.start_time ? false : true;
			diff_item[`${this.diff_flag}booking_end_time`] = booking.booking_end_time === item.end_time ? false : true;
			diff_item[`${this.diff_flag}rate_fc`] = booking.rate_fc === item.rate ? false : true;
			diff_item[`${this.diff_flag}program_name`] = booking.program_name === item.program ? false: true;
			diff_item[`${this.diff_flag}pos_in_break`] = booking.pos_in_break === item.pos_in_break ? false: true;
			diff_item[`${this.diff_flag}material_key_identifier`] = booking.material_key_identifier === item.key_number ? false : true;
			diff_item[`${this.diff_flag}priority_modifier`] = booking.priority_modifier === item.prority_modifier ? false : true;
			
			is_exception = Object.values(diff_item).some(item => { return item === true });
		
			if (!is_exception) {
				const new_item = JSON.parse(JSON.stringify(item));

				new_item['network_code'] = network_code;
				new_item['checkbox'] = false;

				const phase_obj = { id: booking.phase_id, desc : booking.phase_desc };
				new_item['phase'] = phase_obj;
				new_item['phase_items'] = [phase_obj];

				const supplier_arr = this.supplier_items.filter(supplier => { return supplier.id === booking.supplier.id });
				new_item['outlet'] = supplier_arr[0];
				new_item['original_outlet'] = supplier_arr[0];
				new_item['commission_perc'] = supplier_arr[0].commission_perc;
				new_item['mode'] = new_item.commission_perc === 0 ? Markup_Mode : Commission_Mode;
				new_item['kind'] = { id: booking.kind.id, code: booking.kind.code, display_name: booking.kind.name };
				new_item['media_reference_id'] = item.media_ref;
				new_item['contract_ref'] = item.contract;
				new_item['booking_day_flags'] = item.day_flags.length !== 0 ? item.day_flags.split("") : [];
				new_item['booking_start'] = this.calculateBookedDate(item.booked_date, item.day_flags);
				new_item['booking_end'] = this.calculateBookedEnd(item.booked_date, item.day_flags);
				new_item['booking_duration'] = `${item.duration} sec`;
				new_item['booking_start_time'] = item.start_time.length === 0 ? '' : `${item.start_time.substring(0,2)}:${item.start_time.substring(2,4)}`;
				new_item['booking_end_time'] = item.end_time.length === 0 ? '' : `${item.end_time.substring(0,2)}:${item.end_time.substring(2,4)}`;
				new_item['cost_currency'] = booking.cost_currency;
				new_item['value_currency'] = booking.value_currency;
				new_item['rate_fc'] = item.rate;
				new_item['value_fc'] = booking.value_fc; 
				new_item['program_name'] = item.program;
				new_item['material_key_identifier'] = item.key_number;
				new_item['priority_modifier'] = item.prority_modifier;
				new_item['custom1'] = '';
				new_item['custom2'] = '';
				new_item['custom3'] = '';
				new_item['custom4'] = '';
				new_item['custom5'] = '';
				new_item['parent_id'] = 0;
				new_item['has_child'] = true;
				new_item['is_last'] = false;				

				return [new_item];
			} else {
				return [];
			}
		},
		getRowStyle(item_obj) {
			let style_str = '';

			if (item_obj.parent_id === 0) {
				if (item_obj.has_child) {
					style_str = 'border-bottom: thin solid transparent'
				} else {
					style_str = ''
				}
			} else {
				if (item_obj.is_last) {
					style_str = '';
				} else {
					style_str = 'border-bottom: thin solid transparent'
				}
			}

			return style_str
		},
		getDateRange(holdings) {
			let date_ramge = [];

			if (holdings.length !== 0) {
				/** merge date */
				const date_arr = holdings.map(h => { return moment(h.booked_date).format('YYYY-MM-DD') });
				const unique_date_arr = [...new Set(date_arr)];

				unique_date_arr.sort((a, b) => {
					const date_a = moment(a, 'YYYYMMDD').format('YYYY-MM-DD');
					const date_b = moment(b, 'YYYYMMDD').format('YYYY-MM-DD');
					return new Date(date_a) - new Date(date_b);
				});
				
				date_ramge = [moment(unique_date_arr[0]).format('YYYY-MM-DD'), moment(unique_date_arr[unique_date_arr.length - 1]).format('YYYY-MM-DD')];
			}

			return date_ramge;
		},
		async getSupplierList() {
			this.loading = true;

			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						data.forEach(d => {
							if (d.kind) {
								d.kind['display_name'] = d.kind.name;
							}

							d['desc'] = `${d.code} - ${d.display_name}`;
						});
						this.supplier_items = data;					
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onSelectColumn() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const win_setup_obj = {
				column: columns
			};
			const win_setup = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup).catch((e) => {
				this.error_msg = e;
			});
		},
		onDateChange(value_arr, id) {
			if (value_arr.length !== 2) return;
			value_arr.sort();
			const date_range = value_arr;

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = holdings.filter(hold => {
				const date = hold.booking_start;
				const is_fall_range = this.isFallRange(date, date_range);

				if (is_fall_range) {
					return hold;
				}
			});

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastWeek(id) {
			const last_week_start = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
			const last_week_end = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
			const date_range = [last_week_start, last_week_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = holdings.filter(hold => {
				const date = hold.booking_start;
				const is_fall_range = this.isFallRange(date, date_range);
				if (is_fall_range) {
					return hold;
				}
			});

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastMonth(id) {
			const last_month_start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
			const last_month_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
			const date_range = [last_month_start, last_month_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = holdings.filter(hold => {
				const date = hold.booking_start;
				const is_fall_range = this.isFallRange(date, date_range);
				if (is_fall_range) {
					return hold;
				}
			});

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onHistoryClick(item) {
			this.history_ref_id = item;
			this.history_visible = true;
		},
		formatDateRange(date) {
			return `${moment(date[0]).format('DD MMM')} - ${moment(date[1]).format('DD MMM')}`;
		},
		formatDate(date_str) {
			return `${moment(date_str).format('DD MMM YYYY')}`;
		},
		formatNumber(rate) {
			const number = Number(rate);
			if (!Number.isFinite(number)) return rate;

			return number.toLocaleString('en-AU', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.headers.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`] !== null || item_obj[`${header}`] !== undefined ? item_obj[`${header}`] : '';
			});

			return filter_obj;
		},
		calculateBookedDate(booked_date, day_flags) {
			let booking_start = '';

			if (booked_date && day_flags && booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_start = current_date.format('YYYY-MM-DD');
							break;
						}
					}
				}
			}

			return booking_start;
		},
		calculateBookedEnd(booked_date, day_flags) {
			let booking_end = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_end = current_date.format('YYYY-MM-DD');
						}
					}
				}
			}

			return booking_end;
		},
		isFallRange(date, date_range) {
			let is_fall_range = false;

			if (date_range.length === 0) {
				is_fall_range = true;
			} else {
				if (moment(date).isSame(date_range[0]) || moment(date).isSame(date_range[1]) || moment(date).isBetween(date_range[0], date_range[1])) {
					is_fall_range = true;
				}
			}

			return is_fall_range
		},
		getPaginationTotal(list_length) {
			return Math.ceil(list_length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;
		},
		errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		}
	}
}
</script>

<style lang="scss" scoped>
.file-list-title {
  font-family: Roboto;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.5px;
  color: #4742C6;
}
 .file-list-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	// line-height: 36px;
	letter-spacing: 0.5px;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	// line-height: 36px;
	letter-spacing: 0.5px;
}
.font-header-style {
	color: #192A3E;
}
.header-background-color {
	background-color: #EAEAEA;
}
.holding-cell {
	width: auto;
	min-width: 120px;
	max-width: 240px;
}
.holding-cell .row {
	min-width: 0;
	width: 100%;
}
.holding-cell .long-text {
	display: block;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.table-header-row {
	align-items: center;
	flex-wrap: nowrap;
	min-height: 60px;
}
.panel-icon {
	order: 0;
}
.panel-header {
	order: 1;
}
.truncate-2 {
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: initial;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}
.option-text {
	margin: 0 4px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #192A3E;
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.v-data-table__wrapper {
		overflow-x: auto;
	}
	table {
		width: max-content;
		min-width: 100%;
		table-layout: auto;
	}
	th,
	td {
		width: auto !important;
		white-space: nowrap;
		vertical-align: middle;
	}
	.v-expansion-panel-content__wrap {
		padding: 0 16px 0 !important;
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
	}
}
</style>
